/** 地図画面コンポーネント */
<template>
  <b-container id="the-Member">
    <b-row class="container-member">
      <b-col cols="4" class="view-member" v-show="isListViewShown">
        <b-row no-gutters class="tab-bar">
          <div class="tab-container">
            <div
              class="tab"
              v-bind:class="{
                'active': isTabContentUser,
              }"
              v-t="'theMember.user'"
              v-on:click="tabContentType = TAB_CONTENT_TYPE.USER"
            />
            <div
              v-if="isIndoorAvailable"
              class="tab"
              v-bind:class="{
                'active': isTabContentIndoorSiteBuilding,
              }"
              v-t="'theMember.indoorSiteBuilding'"
              v-on:click="
                tabContentType = TAB_CONTENT_TYPE.INDOOR_SITE_BUILDING
              "
            />
            <div
              class="tab"
              v-bind:class="{
                'active': isTabContentPlace,
              }"
              v-t="'theMember.place'"
              v-on:click="tabContentType = TAB_CONTENT_TYPE.PLACE"
            />
          </div>
          <!-- 更新 -->
          <div class="tab-bar-reload">
            <div class="label" v-show="listUpdatedDateLabel">
              {{ $t('theMember.listUpdate.field') }} :
              {{ listUpdatedDateLabel }}
            </div>
            <button-reload v-on:click="$_onClickReload" />
          </div>
        </b-row>
        <b-row no-gutters class="tab-content">
          <!-- ユーザー -->
          <member-user
            v-bind:show="isTabContentUser"
            v-bind:users="users"
            v-bind:is-loading="isLoading"
            v-bind:condition="condition"
            v-bind:sort-rule="userSortRule"
            v-bind:additional-items="additionalItems"
            v-bind:is-card-simple="isUserCardSimple"
            v-on:user-card-click="$_onClickUserItem"
            v-on:condition-changed="updateCondition"
            v-on:sort-rule-changed="userSortRule = $event"
            v-on:additional-items-changed="additionalItems = $event"
            v-on:is-card-simple-changed="isUserCardSimple = $event"
          />
          <!-- サイト・ビル -->
          <template v-if="isIndoorAvailable">
            <member-indoor-item
              v-bind:show="isTabContentIndoorSiteBuilding"
              v-bind:show-tag-user-count="$store.state.user.hasTagUser"
              v-bind:users="users"
              v-bind:indoor-places="indoorPlaces"
              v-bind:condition="condition"
              v-on:condition-changed="updateCondition"
              v-on:target-ids-changed="updateTargetIdsToRender"
              v-on:selected-id-changed="targetIdToFit = $event"
              v-on:indoor-site-name-click="$_showIndoorSiteDetail"
              v-on:indoor-building-name-click="$_showIndoorBuildingDetail"
            />
          </template>
          <!-- プレイス -->
          <member-place
            ref="member-place"
            v-bind:show="isTabContentPlace"
            v-bind:limit="100"
            v-bind:bounds="mapBounds"
            v-bind:condition="condition"
            v-bind:can-fit-map-to-alone="enableFitMap"
            v-on:target-ids-changed="updateTargetIdsToRender"
            v-on:item-click="$_onClickPlaceItem"
            v-on:name-click="$_showPlaceDialog"
          />
        </b-row>
      </b-col>
      <b-col v-bind:cols="viewCols.right" class="view-map">
        <!-- 地図 -->
        <map-control
          ref="map-control"
          id="member-map-control"
          v-bind="$store.getters.mapControlBinds"
          v-bind:id-prefix="'member-'"
          v-bind:reactive-render="!isModalOverlaid"
          v-bind:layer-renderers="renderers"
          v-bind:layer-menu-data="layerMenuData"
          v-bind:onIfieldApiError="handleApiError"
          v-on:indoor-level-selected="$_onIndoorLevelChangedFromMap"
          v-on:map-control-initend="$_onMapInitEnd"
          v-on:map-control-bounds-changed="mapBounds = $event"
          v-on:menu-layers-visible-changed="$_onLayerMenuVisibleChanged"
        >
          <template
            v-slot:default="{ currentMapComponent, clientRect, zoom, center }"
          >
            <!-- 屋内建物の Popup -->
            <map-popup-indoor-building
              v-bind:current-map-component="currentMapComponent"
              v-bind:map-client-rect="clientRect"
              v-on:map-popup-building-detail-click="$_showIndoorBuildingDetail"
            />
            <template v-for="cluster in clusters">
              <map-popup
                v-if="cluster.fixPopup || cluster.showPopup"
                v-bind:key="`${cluster.id}-member-cluster-popup`"
                v-bind:id-prefix="'member'"
                v-bind:current-map-component="currentMapComponent"
                v-bind:map-center="center"
                v-bind:map-zoom="zoom"
                v-bind:coordinates="cluster.geometry.coordinates"
                v-bind:data="cluster"
                v-bind:offset="popup.offset"
                v-bind:placement="popup.placement"
                v-on:shown="popup.id = $event"
                v-on:hidden="popup.id = null"
                v-on:popup-mouseenter="onPopupMouseEnter"
                v-on:popup-mouseleave="onPopupMouseLeave"
              >
                <template v-slot:default="{ data }">
                  <map-popup-content-user
                    v-bind:data="data.properties.children"
                    v-bind:sortFunction="sortFunctionForPopup"
                    v-bind:disp-item="labelDispItem"
                    v-bind:base-date="baseDate"
                    v-on:detail-click="$_showProfileModal"
                  />
                </template>
              </map-popup>
            </template>
          </template>
          <template v-slot:map-left-top>
            <!-- ビル表示ボタン -->
            <map-indoor-building-button
              v-bind:indoor-building="
                $store.getters['mapIndoor/activeIndoorBuilding']
              "
              class="map-control-ui"
              v-on:reset-click="unselectedBuilding"
            />
            <!-- リスト切り替えタブ -->
            <list-view-toggle-tab
              v-model="isListViewShown"
              v-bind:listViewCols="viewCols.left"
              v-bind:idPrefix="'member'"
              class="map-control-ui list-tab"
              v-on:listview-toggletab-toggled="$_toggleListViewShown"
            />
          </template>
        </map-control>
      </b-col>
    </b-row>

    <place-detail
      ref="place-detail"
      v-on:place-searchreport-click="$_showReport"
      v-on:place-searchuser-click="$_showUsersNearPlace"
      v-on:hide-modal="$_onHidePlaceDetail"
    />
    <indoor-site-detail ref="indoor-site-detail" />
    <indoor-building-detail
      ref="indoor-building-detail"
      v-on:indoor-building-fit-map="fitToBounds"
    />
    <map-layer-controller
      v-bind:layer-render-parameters="mapLayerRenderParameters"
      v-on:map-layer-renderers-created="mapLayerRenderers = $event"
    />
    <!-- モーダル重畳検知 -->
    <modal-overlay-detector
      v-on:is-modal-overlaid-changed="$_onModalOverlayChanged"
    />
  </b-container>
</template>

<script>
import MapPopupIndoorBuilding from '@/components/indoor/AppMapPopupIndoorBuilding.vue'
import ButtonReload from '@/components/AppButtonReload.vue'
import MemberUser from '@/components/member/AppMemberUser.vue'
import MemberIndoorItem from '@/components/member/AppMemberIndoorItem.vue'
import MemberPlace from '@/components/member/AppMemberPlace.vue'
import ListViewToggleTab from '@/components/AppListViewToggleTab.vue'
import PlaceDetail from '@/views/ThePlaceDetail.vue'
import IndoorSiteDetail from '@/views/TheIndoorSiteDetail.vue'
import IndoorBuildingDetail from '@/views/TheIndoorBuildingDetail.vue'
import MapLayerController from '@/components/map/AppMapLayerController.vue'
import BvModalOverlayDetector from '@/components/AppBvModalOverlayDetector.vue'
import ModalUtil from '@/js/util/ModalUtil.js'
import { MapPopup } from 'ifield-core-components'
import { MapIndoorBuildingButton } from 'ifield-core-components'
import MapPopupContentUser from '@/components/AppMapPopupContentUser.vue'
import TippedIconRenderer from '@/js/map-renderer/TippedIconRenderer.js'
import PlaceLabelRenderer from '@/js/map-renderer/PlaceLabelRenderer.js'
import VARIABLES from '@/assets/scss/variables.module.scss'
import { loadUserLabelIconAtlas } from '@/js/util/UserLabelIconAtlas.js'
import {
  getItemDotColor,
  getItemIcon,
  getItemText,
} from '@/js/util/UserLabelItemText.js'
import {
  EMPTY_ITEM_TEXT,
  buildLabelText,
  findLabelItem,
  getDotBorderColor,
  toRgb,
} from '@/js/util/UserLabelUtil.js'
import {
  MapLayerMVTRenderer,
  RestApiClient,
  TAG_USER_ROLE_ID,
} from 'ifield-core-components'
import { shallowRef, computed, inject, ref } from 'vue'
import { mapState, mapGetters } from 'vuex'
import {
  FUNCTION_TYPE,
  CLUSTER_ICON_ID,
  CLUSTER_ICON_TEXT_COLOR,
  CLUSTERING_MAP_ID,
} from '@/constants.js'
import moment from 'moment'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'
import { useClusterPopup } from '@/composables/map/UseClusterPopup.js'
import { useUserStatusFilterCondition } from '@/composables/member/UseUserStatusFilterCondition'
import { useUserStatusSortRule } from '@/composables/member/UseUserStatusSortRule'
import { useUserStatusAdditionalItems } from '@/composables/member/UseUserStatusAdditionalItems'
import { useUserStatusCrawler } from '@/composables/member/UseUserStatusCrawler'
import { useFitFeaturesOnMemberMap } from '@/composables/member/UseFitFeaturesOnMemberMap'
import { useMapLayerFilter } from '@/composables/map/UseMapLayerFilter'
import { usePlaceLabel } from '@/composables/map/UsePlaceLabel.js'
import { useLabelCountLimit } from '@/composables/map/UseLabelCountLimit.js'
import { buildLabelDisabledParams } from '@/js/util/MapLayerLabelParams.js'
import { useMapIndoorStore } from '@/composables/map/UseMapIndoorStore'
import { countUsersByType } from '@/js/util/clusterUtil'

/**
 * タブコンテンツの種類
 */
const TAB_CONTENT_TYPE = {
  USER: 'user',
  INDOOR_SITE_BUILDING: 'indoor',
  PLACE: 'place',
}

// レイヤーID
const LAYER_ID = 'user'

// ラベルの背景色（色の丸に枠線が要るかの判定に使う）
const LABEL_BACKGROUND = '#ffffff'

// ラベルの表示項目を省略したことを知らせるまでの待ち(ms)
// 地図が目的地へ移動している途中の一瞬の状態で知らせないための間
const LABEL_ITEM_OMITTED_NOTICE_DELAY = 1500

// レンダラーファクトリ
const rendererFactory = new TippedIconRenderer({ layerId: LAYER_ID })

// プレイスラベルのレンダラーファクトリ
const placeLabelRendererFactory = new PlaceLabelRenderer()

/**
 * 地図画面
 */
export default {
  name: 'TheMember',
  components: {
    'button-reload': ButtonReload,
    'member-user': MemberUser,
    'member-indoor-item': MemberIndoorItem,
    'member-place': MemberPlace,
    'map-popup': MapPopup,
    'map-popup-content-user': MapPopupContentUser,
    'map-indoor-building-button': MapIndoorBuildingButton,
    'list-view-toggle-tab': ListViewToggleTab,
    'place-detail': PlaceDetail,
    'indoor-site-detail': IndoorSiteDetail,
    'indoor-building-detail': IndoorBuildingDetail,
    'map-layer-controller': MapLayerController,
    'modal-overlay-detector': BvModalOverlayDetector,
    'map-popup-indoor-building': MapPopupIndoorBuilding,
  },
  props: {
    /**
     * プレイスID
     */
    placeId: {
      type: Number,
      default: null,
    },
    /**
     * フロアID
     */
    indoorLevelId: {
      type: Number,
      default: null,
    },
  },
  setup(props, context) {
    /**
     * AppMapControlのインスタンス
     */
    const map = shallowRef(null)
    /**
     * 屋内プレイス
     */
    const indoorPlaces = shallowRef([])
    /**
     * 地図表示領域
     */
    const mapBounds = shallowRef(null)

    // 共通使用
    const { handleApiError } = useHandleApiError(props, context)
    const baseDate = inject('baseDate')

    // 地図表示対象IDフィルタリング
    const {
      targetIds: targetIdsToRender,
      updateTargetIds: updateTargetIdsToRender,
      layerRenderParameters,
    } = useMapLayerFilter()
    // プレイスラベル（吹き出し）の値の取得と組み立て
    const { isPlaceLabelEnabled, isPlaceLabelOverLimit, placeLabelData } =
      usePlaceLabel({
        mapBounds,
        renderParameters: layerRenderParameters,
      })
    /**
     * 画面に出るユーザーラベルの件数
     *
     * クラスタリングの結果から数える。まとめられた点にはラベルの2段目が無いので対象外
     * @type {Ref.<Number>}
     */
    const userLabelCount = ref(0)
    const { isOverLimit: isUserLabelOverLimit } =
      useLabelCountLimit(userLabelCount)
    // ビル・フロア変更処理
    const { changeIndoorBuilding, unselectedBuilding, setActiveIndoorLevelId } =
      useMapIndoorStore()
    // ユーザーレイヤーのポップアップ
    const {
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
    } = useClusterPopup()

    // 各種ユーザー表示条件
    const {
      condition,
      conditionForRequest,
      updateCondition,
      applyParameter: applyParameterToCondition,
      applyMapIndoorState,
    } = useUserStatusFilterCondition(props)
    const { sortRule, applyParamter: applyParameterToSortRule } =
      useUserStatusSortRule(props)
    const { items, isSimple, selectableItems } = useUserStatusAdditionalItems()

    // リクエストトリガー監視用絞り込み条件
    const conditionForWatch = computed(() =>
      JSON.stringify(conditionForRequest.value)
    )

    // ユーザーデータ取得
    const {
      usersOnDate,
      fetchedDate,
      fetchForce,
      isErrorShown,
      startAutoUpdate,
      stopAutoUpdate,
    } = useUserStatusCrawler({
      items,
      condition: conditionForRequest,
      sortRule,
      baseDate,
    })

    // 地図fit
    const {
      targetId: targetIdToFit,
      enable: enableFitMap,
      fitToBounds,
      fitToGeometry,
      fitToUsers,
    } = useFitFeaturesOnMemberMap({
      map,
      indoorPlaces,
      condition,
      users: usersOnDate,
    })

    return {
      map,
      indoorPlaces,
      handleApiError,
      baseDate,
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
      condition,
      conditionForWatch,
      updateCondition,
      applyParameterToCondition,
      applyMapIndoorStateToCondition: applyMapIndoorState,
      userSortRule: sortRule,
      applyParameterToSortRule,
      additionalItems: items,
      labelSelectableItems: selectableItems,
      isUserCardSimple: isSimple,
      users: usersOnDate,
      fetchedDate,
      fetchForce,
      isFetchErrorShown: isErrorShown,
      startAutoUpdate,
      stopAutoUpdate,
      targetIdsToRender,
      updateTargetIdsToRender,
      mapBounds,
      layerRenderParametersOfMap: layerRenderParameters,
      isPlaceLabelEnabled,
      isPlaceLabelOverLimit,
      placeLabelData,
      userLabelCount,
      isUserLabelOverLimit,
      changeIndoorBuilding,
      unselectedBuilding,
      setActiveIndoorLevelId,
      targetIdToFit,
      enableFitMap,
      fitToBounds,
      fitToGeometry,
      fitToUsers,
    }
  },
  data: function () {
    return {
      /**
       * ページが表示されている場合はtrue
       * keep-alive で保持されるため、非表示でも破棄されない
       * @type {Boolean}
       */
      isViewActive: true,
      /**
       * タブコンテンツの種類
       * @type {String}
       */
      tabContentType: TAB_CONTENT_TYPE.USER,
      /**
       * ラベルの表示項目を省略した知らせを出すまでの待ち（対象ごと）
       * @type {Object.<String, Number>}
       */
      labelItemOmittedTimers: {},
      /**
       * リストビューを表示する場合true
       * @type {Boolean}
       */
      isListViewShown: true,
      /**
       * ロード中の場合はtrue
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * モーダルが重畳している場合はtrue
       * @type {Boolean}
       */
      isModalOverlaid: false,
      /**
       * マップレイヤーのレンダラー
       * @type {Array.<Object>}
       */
      mapLayerRenderers: [],
      /**
       * レイヤー表示状態
       * @type {Object}
       */
      visible: {
        geometry: true,
        label: true,
      },
      /**
       * 自データのレイヤーレンダラー
       * @type {Object}
       */
      myRenderer: null,
      /**
       * リロード中フラグ
       * @type {Boolean}
       */
      isReloading: false,
      /**
       * ラベル2段目のアイコン画像
       * @type {Object|null}
       */
      labelIconAtlas: null,
      /**
       * ラベル2段目のアイコンの位置の対応表
       * @type {Object|null}
       */
      labelIconMapping: null,
    }
  },
  computed: {
    ...mapGetters('mapLayer', ['clickedPlace', 'mapLayers']),
    ...mapGetters('map', ['zoom']),
    ...mapState('userMarker', ['iconAtlas', 'iconMapping']),
    ...mapGetters('mapIndoor', [
      'activeIndoorLevelId',
      'activeIndoorBuildingId',
    ]),
    ...mapGetters('indoorSite', ['indoorSiteMap']),
    ...mapGetters('indoorBuilding', ['indoorBuildingMap']),
    ...mapGetters('indoorLevel', ['indoorLevels']),
    /**
     * ラベルの2段目に出す表示項目
     *
     * 「1番目」はシステム設定 `user_disp_item` の順の1番目。
     * 2026-08-20 の打ち合わせで、**ラベルは一覧の表示項目の変更や簡易表示の影響を受けず、
     * 管理画面で設定した表示項目の先頭を出し続ける**と決まった。
     * このため利用者が非表示にしたものを除く `additionalItems` ではなく、
     * 権限で使えるものだけを除いた `labelSelectableItems` の先頭を使う。
     *
     * 2段目を出すかどうかは個人設定（既定OFF・決定3-1）。OFFのときは null を返して
     * 表示項目が無いときと同じ扱いにする＝ラベルはユーザー名だけの1行になる
     * @type {String|null}
     */
    labelDispItem: function () {
      if (!this.$store.state.labelSecondLine.user) return null
      // 件数が多すぎるときは2段目を出さず、名前だけの1行に戻す（2026-08-26 合意）
      if (this.isUserLabelOverLimit) return null
      return this.labelSelectableItems?.[0] || null
    },
    /**
     * クラスタリング実行フラグ
     * @type {Boolean}
     */
    enableClustering: function () {
      return this.$store.getters.isClusteringEnabled(CLUSTERING_MAP_ID.USER)
    },
    /**
     * 屋内機能が利用可能か？
     * @type {Boolean}
     */
    isIndoorAvailable: function () {
      return !!this.$store.getters.functionType(FUNCTION_TYPE.INDOOR)
    },
    /**
     * マップレイヤーの描画パラメータ
     *
     * プレイスの吹き出しを画面側で描く間は、タイル側のラベルを消して二重表示を防ぐ。
     * 描画パラメータは地図画面が自前で持っているので、他の画面には影響しない（決定5）
     * @type {Array.<Object>}
     */
    mapLayerRenderParameters: function () {
      if (!this.isPlaceLabelEnabled) return this.layerRenderParametersOfMap
      return buildLabelDisabledParams({
        globalParams: this.layerRenderParametersOfMap,
        mapLayers: this.mapLayers,
        mvtLayerId: MapLayerMVTRenderer.layerId,
      })
    },
    /**
     * プレイスラベルのレンダラー
     * @type {Object|null}
     */
    placeLabelRenderer: function () {
      if (!this.isPlaceLabelEnabled) return null
      return placeLabelRendererFactory.createRenderer(this.placeLabelData, {
        iconAtlas: this.labelIconAtlas,
        iconMapping: this.labelIconMapping,
      })
    },
    /**
     * 地図binding用render関数配列
     * @type {Array.<Function>}
     */
    renderers: function () {
      const renderers = [...this.mapLayerRenderers]
      if (this.placeLabelRenderer) {
        renderers.push(this.placeLabelRenderer)
      }
      if (this.myRenderer) {
        renderers.push(this.myRenderer)
      }
      return renderers.map((r) => r.render)
    },
    /**
     * レイヤーメニュー用データ
     * @type {Array.<Object>}
     */
    layerMenuData: function () {
      const data = [...this.$store.getters['map/layerMenu/layerMenuData']]
      if (this.myRenderer) {
        data.unshift({
          id: this.myRenderer.id,
          name: this.$t('theMember.layer.user'),
          visible: this.visible,
          labeled: true,
          geometryTypes: ['Point'],
          color: VARIABLES.ENTITY_COLOR_ORANGE_RED,
        })
      }
      return data
    },
    /**
     * 表示中ユーザーID配列
     * @type {Array.<String>}
     */
    userIds: function () {
      return this.users.map((user) => user.id)
    },
    /**
     * ポップアップ内のリストソート関数
     * @type {Function}
     */
    sortFunctionForPopup: function () {
      return (a, b) => {
        // ユーザーリストと順序を同期
        return (
          this.userIds.findIndex((id) => id === a.id) -
          this.userIds.findIndex((id) => id === b.id)
        )
      }
    },
    /**
     * 全ての屋内レベルID
     * @type {Array.<Number>}
     */
    allIndoorLevelIds: function () {
      return this.indoorLevels.map((level) => level.id)
    },
    /**
     * タブコンテンツの種類定義
     * @type {Object}
     */
    TAB_CONTENT_TYPE: function () {
      return TAB_CONTENT_TYPE
    },
    /**
     * タブコンテンツがユーザーの場合はtrue
     * @type {Boolean}
     */
    isTabContentUser: function () {
      return this.tabContentType === TAB_CONTENT_TYPE.USER
    },
    /**
     * タブコンテンツがサイト・ビルの場合はtrue
     * @type {Boolean}
     */
    isTabContentIndoorSiteBuilding: function () {
      return this.tabContentType === TAB_CONTENT_TYPE.INDOOR_SITE_BUILDING
    },
    /**
     * タブコンテンツがプレイスの場合はtrue
     * @type {Boolean}
     */
    isTabContentPlace: function () {
      return this.tabContentType === TAB_CONTENT_TYPE.PLACE
    },
    /**
     * 屋内アクティブにすべきビルID
     * condition.indoorで以下の条件を満たす場合に限り値が入る
     * * ビルが1つだけ選択されている
     * * フロアが選択されている
     * @type {Number}
     */
    indoorBuildingIdForActive: function () {
      const {
        indoor: { indoorBuildingIds, indoorLevelId },
      } = this.condition
      if (
        !indoorBuildingIds ||
        indoorBuildingIds.length !== 1 ||
        !indoorLevelId
      )
        return null
      return indoorBuildingIds[0]
    },
    /**
     * ビュー分割のcol数
     */
    viewCols: function () {
      return this.isListViewShown
        ? { left: 4, right: 8 }
        : { left: 0, right: 12 }
    },
    /**
     * 表示用の一覧の最終更新日
     * @return {string}
     */
    listUpdatedDateLabel: function () {
      if (!this.fetchedDate) return ''
      return moment(this.fetchedDate).format(
        this.$t('theMember.listUpdate.format')
      )
    },
  },
  watch: {
    /**
     * 表示範囲が変わったらユーザーラベルの件数を数え直す
     *
     * クラスタリングは世界全体で計算され、地図を動かしただけでは通知が来ないため
     */
    mapBounds: function () {
      this.userLabelCount = this.$_countUserLabelsInView(
        this._clusteredFeatures
      )
    },
    /**
     * ユーザーラベルの表示項目を省略し始めたことを知らせる
     * @param {Boolean} value 省略しているか
     */
    /**
     * ラベルの2段目に出す表示項目が変わったらラベルを描き直す
     *
     * ラベルの文字は `$_updateUserLayer` のときに `$_buildLabelInfo` でまとめて
     * 組み立てているため、ここで呼ばないと個人設定を変えても
     * 次のユーザー情報の更新まで古い表示が残る
     */
    labelDispItem: function () {
      this.$_updateUserLayer(true)
    },
    isUserLabelOverLimit: function (value) {
      this.$_notifyLabelItemOmitted(
        value,
        'user',
        this.$t('theMember.message.labelItemOmittedUser')
      )
    },
    /**
     * プレイスラベルの表示項目を省略し始めたことを知らせる
     * @param {Boolean} value 省略しているか
     */
    isPlaceLabelOverLimit: function (value) {
      this.$_notifyLabelItemOmitted(
        value,
        'place',
        this.$t('theMember.message.labelItemOmittedPlace')
      )
    },
    users: function () {
      // ピンイメージの更新は少し時間がかかるので $_updateUserLayer で先に位置だけを更新して
      // updateTexture => iconAtlas の watcher で地図上のピンイメージを再描画する
      // リロードフラグは地図上のピンイメージの更新トリガーまで終わってから戻す
      // ラベルは文字単位で描くので、画像を作る処理は要らない
      Promise.all([
        this.$_updatePinImage(this.isReloading).then(() =>
          this.$store.dispatch('userMarker/updateTexture', this.isReloading)
        ),
        this.$_updateUserLayer(),
      ]).then(() => {
        this.isReloading = false
      })
    },
    zoom: function () {
      // レイヤー更新
      this.users.length && this.$_updateUserLayer()
    },
    visible: function () {
      this.$store.dispatch('member/setVisible', this.visible)
      this.$_updateUserLayer()
    },
    enableClustering: function () {
      this.$_updateUserLayer()
    },
    iconAtlas: function () {
      this.$_updateUserLayer()
    },
    // 絞り込み条件設定で屋内に出入りが必要なときの処理
    indoorBuildingIdForActive: function (value) {
      if (value) {
        // 地図側の屋内建物更新
        const building = this.indoorBuildingMap.get(value)
        building && this.changeIndoorBuilding(building)
      } else {
        this.changeIndoorBuilding(null)
      }
    },
    // 絞り込み条件設定でフロアだけが変更されたときの処理
    'condition.indoor.indoorLevelId': function (value) {
      if (value) {
        this.setActiveIndoorLevelId(value)
        if (this.indoorBuildingIdForActive) {
          const building = this.indoorBuildingMap.get(
            this.indoorBuildingIdForActive
          )
          building && this.changeIndoorBuilding(building)
        }
      }
    },
    // 地図側でフロア変更したときの処理
    activeIndoorLevelId: function (value) {
      if (value) {
        this.applyMapIndoorStateToCondition()
      }
    },
    // 地図側で屋内に出入りしたときの処理
    activeIndoorBuildingId: function (value) {
      if (!value) {
        // サイト・ビルタブの表示対象がそのまま condition に復元されるようにする
        this.updateCondition({
          indoor: {
            indoorSiteIds: this.targetIdsToRender.indoorSite,
            indoorBuildingIds: this.targetIdsToRender.indoorBuilding,
            indoorLevelId: null,
          },
          place: {
            placeId: null,
          },
        })
      }
    },
    clickedPlace(value) {
      // Click された Feature が変更された
      // プレイス詳細ダイアログを表示する
      this.$log.debug('[clickedPlace] ', value)
      // 保持されている非表示のページでも watcher は動くので、表示中のページだけが開く
      if (value && this.isViewActive && !this.isModalOverlaid) {
        this.$_showPlaceDialog(value.properties.place_id)
      }
    },
    conditionForWatch: function () {
      // ユーザー取得後に地図をフィットする
      this.$_updateUsers(true)
    },
    userSortRule: {
      deep: true,
      handler: function () {
        // ユーザー取得後に地図をフィットしない
        this.$_updateUsers()
      },
    },
    additionalItems: function () {
      // ユーザー取得後に地図をフィットしない
      this.$_updateUsers()
    },
  },
  created: function () {
    this.$_loadLabelIcons()
    this.$_updateUserDispItems()
    this.$_updateIndoorSite()
    this.$_updateIndoorBuilding()
    this.$_updateIndoorLevel().then(() => {
      this.allIndoorLevelIds.length && this.$_getIndoorPlaces()
    })
  },
  mounted: function () {
    this.$log.debug('[DEBUG] TheMember mounted')
    this.$_updateUsers(true)

    // 表示状態復元
    this.visible = this.$store.getters['member/visible']

    // 建物のピンをクリック時にアクティブにさせないようにする
    this.$store.commit('mapIndoor/setClickBuildingPinToActive', false)
  },
  beforeDestroy: function () {
    this.$log.debug('[DEBUG] TheMember beforeDestroy')
    // 建物のピンをクリック時にアクティブにする (元に戻す)
    this.$store.commit('mapIndoor/setClickBuildingPinToActive', true)
    // 画面を離れたあとに知らせが出ないようにする
    for (const timer of Object.values(this.labelItemOmittedTimers)) {
      clearTimeout(timer)
    }
  },
  activated: function () {
    // 初回描画時は created / mounted で初期化済みなので何もしない
    if (this.isViewActive) return
    this.$log.debug('[DEBUG] TheMember activated')
    this.isViewActive = true

    // 建物のピンをクリック時にアクティブにさせないようにする
    this.$store.commit('mapIndoor/setClickBuildingPinToActive', false)
    // 自動更新を再開する
    this.startAutoUpdate()

    if (this.placeId) {
      // 他のページからプレイスを指定して遷移してきた場合は絞り込み条件に反映する
      // ユーザーの取得は絞り込み条件の監視で行われる
      this.applyParameterToCondition({
        placeId: this.placeId,
        indoorLevelId: this.indoorLevelId,
      })
      this.applyParameterToSortRule({ placeId: this.placeId })
    } else {
      this.$_updateUsers(true)
    }
  },
  deactivated: function () {
    this.$log.debug('[DEBUG] TheMember deactivated')
    this.isViewActive = false
    // 表示していない間は自動更新しない
    this.stopAutoUpdate()
    // 建物のピンをクリック時にアクティブにする (元に戻す)
    this.$store.commit('mapIndoor/setClickBuildingPinToActive', true)
    // 開いたままのダイアログを閉じる
    ModalUtil.hideAllIn(this)
  },
  methods: {
    /**
     * ラベルに出す内容をユーザーごとに1回だけ組み立てる
     *
     * 表示項目の値の組み立てはリストと同じ処理を通すため軽くない。
     * 描画のたびに地物ごとに呼ばれると更新1回あたりの負担が大きくなるので、
     * 更新のたびにここでまとめて作り、描画側は引くだけにする
     * @returns {Map.<Number, Object>} ユーザーIDごとの { text, icon, dot, dotBorder }
     */
    $_buildLabelInfo: function () {
      const dispItem = this.labelDispItem
      // リストと同じ基準日時を使う。取得時刻を使うと「〇分前」がリストとずれる
      const baseDate = this.baseDate
      const info = new Map()
      for (const user of this.users) {
        const item = findLabelItem(user, dispItem)
        const itemText = item ? getItemText(item, baseDate) : ''
        // 2026-08-20 の打ち合わせで、**値が無くても2段目は出す**と決まった。
        // 出さないと吹き出しの高さが人によって変わるため、値が無いときは EMPTY_ITEM_TEXT を出す
        const secondLine = dispItem ? itemText || EMPTY_ITEM_TEXT : ''
        // 表示項目が無い（＝2段目そのものが無い）ときはアイコンも色の丸も出さない。
        // 出すと1行しかないラベルの名前の行に、アイコンぶんの空白だけが空いてしまう
        const color = itemText ? getItemDotColor(item) : null
        // 背景と見分けがつく色なら枠線は付けない（カードと同じ判定）
        const borderColor = getDotBorderColor(color, LABEL_BACKGROUND)
        info.set(user.id, {
          text: buildLabelText(user.user_name, secondLine),
          icon: item ? getItemIcon(item) : null,
          dot: toRgb(color),
          dotBorder: borderColor === color ? null : toRgb(borderColor),
        })
      }
      return info
    },

    /**
     * ラベル2段目のアイコン画像を読み込む
     *
     * 表示項目の数だけの画像でユーザーの件数や値とは無関係なので、画面で1度だけ作る
     */
    $_loadLabelIcons: async function () {
      try {
        const { atlas, mapping } = await loadUserLabelIconAtlas()
        this.labelIconAtlas = atlas
        this.labelIconMapping = mapping
        // 読み込み前に描いたラベルにアイコンを反映する
        this.myRenderer && this.$_updateUserLayer(true)
      } catch (e) {
        // アイコンが出ないだけでラベル自体は描けるので、描画は止めない
        this.$log.error('[ERROR] failed to load label icons', e)
      }
    },
    /**
     * ユーザーリスト表示項目をサーバから取得する
     */
    $_updateUserDispItems: async function () {
      try {
        await this.$store.dispatch(
          'systemSetting/updateSettingByItemKey',
          'user_disp_item'
        )
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.warn(
            'failed to fetch systemSetting/userDispItem. use fetched before.'
          )
        })
      }
    },

    /**
     * 屋内サイト情報更新
     */
    $_updateIndoorSite: async function () {
      try {
        await this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.warn('failed to fetch indoorSites. use fetched before.')
        })
      }
    },

    /**
     * 屋内建物情報更新
     */
    $_updateIndoorBuilding: async function () {
      try {
        await this.$store.dispatch(
          'indoorBuilding/updateIndoorBuildingsWithThrottle'
        )
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.warn('failed to fetch indoorBuildings. use fetched before.')
        })
      }
    },

    /**
     * 屋内レベル情報更新
     */
    $_updateIndoorLevel: async function () {
      try {
        await this.$store.dispatch('indoorLevel/updateIndoorLevelsWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.warn('failed to fetch indoorLevels. use fetched before.')
        })
      }
    },

    /**
     * プレイスを取得する
     */
    $_getIndoorPlaces: async function () {
      const url = RestApiClient.createApiUrl('place')
      url.searchParams.append(
        'indoor_level_id',
        this.allIndoorLevelIds.join(',')
      )
      try {
        const json = await RestApiClient.executeGetApi(url)
        this.indoorPlaces = json.data
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.error('Failed to fetch indoor places')
        })
      }
    },

    /**
     * メンバープロフィール画面を表示する
     * @param {number} userId 表示対象のユーザID
     */
    $_showProfileModal: function (userId) {
      this.$store.dispatch('updateProfileUserId', userId)
    },

    /**
     * プレイス詳細ダイアログを表示する
     * @param {Number} recordId 表示対象のプレイスレコードのID
     */
    $_showPlaceDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['place-detail'].showModal(recordId)
    },

    /**
     * 報告書ページへ遷移する
     * @param {Array.<Number>} placeIds プレイスID配列
     */
    $_showReport: function (placeIds) {
      this.$router.push({
        name: 'report',
        params: {
          defaultPlaceIds: placeIds,
        },
      })
    },

    /**
     * プレイス詳細非表示時処理
     * @param {Boolean} isUpdated 表示されていたプレイスが更新された場合はtrue
     */
    $_onHidePlaceDetail: function (isUpdated) {
      if (isUpdated) {
        // 地図の強制再描画
        const deck = this.map.getMapDeckController()
        deck && deck.render(true)
        // プレイスタブの再更新
        this.$refs['member-place'].refresh()
        // ユーザーリスト更新
        this.$_updateUsers(false)
      }
    },

    /**
     * レイヤーの表示状態変更イベントの処理
     * @param {Array.<Object>} value 表示状態変更値
     */
    $_onLayerMenuVisibleChanged: function (value) {
      for (const { id, visible } of value) {
        if (id === LAYER_ID) {
          this.visible = visible
        }
      }
      this.$store.dispatch('map/setVisible', value)
    },

    /**
     * ベースマップ初期化完了時処理
     */
    $_onMapInitEnd: function () {
      this.map = this.$refs['map-control']
      this.mapBounds = this.map.getBounds()
    },

    /**
     * 地図からフロアが変更になった時の処理
     * @param {number} id 変更後フロアID
     */
    $_onIndoorLevelChangedFromMap: function (id) {
      this.setActiveIndoorLevelId(id)
      this.enableFitMap = false
    },

    /**
     * ユーザ情報を更新する
     * @param {Boolean} fitBounds 地図をfitする場合はtrue
     */
    $_updateUsers: async function (fitBounds) {
      this.$_showLoading()

      try {
        await this.fetchForce()
      } catch (error) {
        this.handleApiError(error)
        this.isFetchErrorShown = true
        this.$_hideLoading()
        return
      }

      // 地図をフィット
      const {
        indoor: { indoorLevelId },
        place: { placeId },
      } = this.condition
      if (fitBounds && !placeId && !indoorLevelId) {
        await this.fitToUsers()
      }
      if (fitBounds) {
        this.enableFitMap = true
      }

      this.$_hideLoading()
    },

    /**
     * 地図上に表示するピン画像データを更新
     * @param {Boolean} force 強制更新する場合はtrue
     */
    $_updatePinImage: async function (force) {
      const userIds = [...new Set(this.users.map((d) => d.id))]
      const promises = userIds.map((id) =>
        this.$store
          .dispatch('userMarker/getImageById', { id, force })
          .catch((error) =>
            this.handleApiError(error, () =>
              this.$log.warn(`failed to update pin image of user ID ${id}.`)
            )
          )
      )
      await Promise.allSettled(promises)
    },

    /**
     * ユーザーレイヤー更新
     * @param {Boolean} force 再描画を強制する場合は true
     */
    $_updateUserLayer: function (force = false) {
      const labelInfo = this.$_buildLabelInfo()
      const props = {
        clustering: this.enableClustering,
        iconAtlas: this.iconAtlas,
        iconMapping: this.iconMapping,
        visible: this.visible,
        zoom: this.zoom,
        getIcon: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            const isFixed = !!cluster?.fixPopup

            // childrenが存在しない、または空の場合はデフォルトを返す
            if (!d.properties.children?.length) {
              return isFixed
                ? CLUSTER_ICON_ID.SELECTED
                : CLUSTER_ICON_ID.DEFAULT
            }

            const userType = d.properties.user_type

            if (userType) {
              // 動的にキーを生成して出し分ける
              const typePrefix = `${userType.toUpperCase()}`
              const stateSuffix = isFixed ? '_SELECTED' : '_DEFAULT'
              const dynamicKey = `${typePrefix}${stateSuffix}`
              if (CLUSTER_ICON_ID[dynamicKey])
                return CLUSTER_ICON_ID[dynamicKey]
            }
            // フォールバック
            return isFixed ? CLUSTER_ICON_ID.SELECTED : CLUSTER_ICON_ID.DEFAULT
          }

          // ユーザー個別マーカー
          if (this.iconMapping[`${d.properties.id}`]) {
            return `${d.properties.id}`
          }

          // アプリ/タグユーザーのデフォルトマーカー
          return d.properties.role_id === TAG_USER_ROLE_ID ? 'tag' : 'default'
        },
        getTextColor: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            return cluster?.fixPopup
              ? CLUSTER_ICON_TEXT_COLOR.SELECTED
              : CLUSTER_ICON_TEXT_COLOR.DEFAULT
          }
        },
        getText: (d) => {
          if (d.properties.cluster) {
            const children = d.properties.children
            if (!children || children.length === 0) {
              return d.properties.point_count
            }
            const { appUsers, tagUsers } = countUsersByType(children)
            if (appUsers > 0 && tagUsers > 0) {
              return `${appUsers}\n${tagUsers}`
            }
            return `${d.properties.point_count}`
          }
        },
        // 1行目はユーザー名、2行目は表示項目の1番目の値。
        // 値の組み立てはユーザー1人につき1回だけ行い、ここでは引くだけにする
        getLabel: (d) => labelInfo.get(d.properties.id)?.text ?? '',
        getLabelIcon: (d) => labelInfo.get(d.properties.id)?.icon ?? null,
        // ステイタスは値の後ろに色の丸を出す（仕様: cluster.png）
        getLabelDotColor: (d) => labelInfo.get(d.properties.id)?.dot ?? null,
        getLabelDotBorderColor: (d) =>
          labelInfo.get(d.properties.id)?.dotBorder ?? null,
        labelIconAtlas: this.labelIconAtlas,
        labelIconMapping: this.labelIconMapping,
        getPosition: (d) => d.geom.geometry.coordinates,
        onClick: ({ object }) => this.$_onClickFeature(object),
        onHover: ({ object }) => this.$_onHoverFeature(object),
        onClustered: (data) => this.$_updateClusterInfo(data),
        updateTriggers: {
          getIcon: [this.iconMapping],
          getLabel: [this.labelDispItem],
          getLabelIcon: [this.labelDispItem, this.labelIconMapping],
        },
      }

      // レイヤー更新を強制するためshallow copy渡す
      this.myRenderer = rendererFactory.createRenderer(
        force ? [...this.users] : this.users,
        props
      )
    },

    /**
     * 地物クリック時処理
     * @param {Object} object クリック地物
     */
    $_onClickFeature: function (object) {
      if (this.isCluster(object)) {
        // レイヤー再描画
        this.$_updateUserLayer(true)
        this.onClickCluster(object)
      } else {
        // クラスタアイコンではないのでユーザー詳細ダイアログを表示
        this.$_showProfileModal(object.properties.id)
      }
    },

    /**
     * 地物ホバー時処理
     * @param {Object|undefined} object クリック地物|ホバー解除時はundefined
     */
    $_onHoverFeature: function (object) {
      // 地物にホバーしている場合はマウスカーソルをポインタに変更
      this.map.currentMapComponent.changeCursor(object ? 'pointer' : '')

      this.isClusterHoverd = this.isCluster(object)
      if (this.isClusterHoverd) {
        this.onHoverCluster(object)
      } else if (!this.isPopupHoverd) {
        // クラスタアイコンとポップアップにホバーしていないのでポップアップを非表示
        this.clusters = this.clusters.map((cluster) => ({
          ...cluster,
          showPopup:
            cluster.id === this.hoveredCluster?.id ? false : cluster.showPopup,
        }))
      }
    },

    /**
     * クラスタ組成情報を更新
     * @param {Array.<Object>} data クラスタデータ
     */
    $_updateClusterInfo: function (data) {
      // 地図を動かしただけでは数え直しが走らないので、数える元を持っておく
      this._clusteredFeatures = data
      this.userLabelCount = this.$_countUserLabelsInView(data)
      this.clusters = data
        .filter((d) => d.properties.cluster)
        .map((d) => ({
          ...d,
          id: d.id || d.properties.id,
          count: d.properties.point_count,
          showPopup: false,
          fixPopup: this.getFixPopupFromCurrentClusterInfo(d),
        }))
        .sort((a, b) => a.id - b.id)
    },

    /**
     * 画面に出るユーザーラベルの件数を数える
     *
     * クラスタリングは世界全体で計算されるため、ここで表示範囲に絞る。
     * まとめられた点の吹き出しには表示項目が出ないので数えない
     * @param {Array.<Object>} data クラスタデータ
     * @returns {Number} 件数
     */
    $_countUserLabelsInView: function (data) {
      const bounds = this.mapBounds
      if (!Array.isArray(bounds?.sw) || !Array.isArray(bounds?.ne)) return 0
      const [west, south] = bounds.sw
      const [east, north] = bounds.ne
      let count = 0
      for (const feature of data || []) {
        if (feature.properties?.cluster) continue
        const point = feature.geometry?.coordinates
        if (!Array.isArray(point)) continue
        const [lng, lat] = point
        if (lat < south || lat > north) continue
        // 日付変更線をまたぐ表示範囲では東西の大小が入れ替わる
        const isInLng =
          west <= east ? lng >= west && lng <= east : lng >= west || lng <= east
        if (!isInLng) continue
        count++
      }
      return count
    },

    /**
     * ラベルの表示項目を省略していることを、表示が落ち着いてから知らせる
     *
     * 地図が目的地へ移動している途中は表示範囲が一瞬だけ広くなることがあり、
     * その一瞬の件数で知らせると「1件のプレイスに寄った直後に多すぎると出る」ことになる。
     * 省略した状態がしばらく続いたときだけ出す
     * @param {Boolean} isOmitted 省略しているか
     * @param {String} target 対象（user / place）
     * @param {String} message 出す文言
     */
    $_notifyLabelItemOmitted: function (isOmitted, target, message) {
      clearTimeout(this.labelItemOmittedTimers[target])
      if (!isOmitted) return
      this.labelItemOmittedTimers[target] = setTimeout(() => {
        this.$_showLabelItemOmittedToast(message)
      }, LABEL_ITEM_OMITTED_NOTICE_DELAY)
    },

    /**
     * ラベルの表示項目を省略していることを知らせる
     * @param {String} message 出す文言
     */
    $_showLabelItemOmittedToast: function (message) {
      this.$toast.fire({
        icon: 'info',
        title: message,
        timer: 2000,
        target: this.map?.$el,
        position: 'bottom',
      })
    },

    /**
     * ユーザー一覧の項目をクリックした時の処理
     * @param {Object} data ユーザーデータ
     */
    $_onClickUserItem: function (data) {
      // 地図のフォーカスを選択したデータに設定する
      this.fitToGeometry(data.geom.geometry)
    },

    /**
     * プレイス一覧の項目をクリックした時の処理
     * @param {Object} data プレイスデータ
     */
    $_onClickPlaceItem: function (data) {
      // 地図のフォーカスを選択したデータに設定する
      this.fitToGeometry(data.geom.geometry)
    },

    /**
     * リロードボタンクリック時処理
     */
    $_onClickReload: function () {
      this.isReloading = true
      this.$_updateUsers()
    },

    /**
     * プレイス近くのユーザーを表示する
     * @param {Object} param { placeId, indoorLevelId }
     */
    $_showUsersNearPlace: function (param) {
      this.applyParameterToCondition(param)
      this.applyParameterToSortRule(param)
      this.tabContentType = TAB_CONTENT_TYPE.USER
    },

    /**
     * 現場詳細表示
     * @param {Number} id 現場ID
     */
    $_showIndoorSiteDetail: function (id) {
      this.$refs['indoor-site-detail'].showModal(id)
    },

    /**
     * 建物詳細表示
     * @param {Number} id 現場ID
     */
    $_showIndoorBuildingDetail: function (id) {
      this.$refs['indoor-building-detail'].showModal(id)
    },

    /**
     * リストビューの表示・非表示を切り替える
     */
    $_toggleListViewShown: function () {
      this.isListViewShown = !this.isListViewShown
    },

    /**
     * モーダル重畳状態変更時処理
     * @param {Boolean} value モーダル重畳状態
     */
    $_onModalOverlayChanged: function (value) {
      this.isModalOverlaid = value
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';
@use '../assets/scss/parts/tool-bar';
@use '../assets/scss/parts/title-bar';

$-tab-height: 40px;

.container-member {
  /*  display: -webkit-box !important; */
  display: flexbox !important;
  margin: 0 !important;
  height: 100%;
}

.view-member {
  width: 100%;
  height: 100%;
  padding: 8px 10px 0 0 !important;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
}

.view-map {
  display: -webkit-box !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  overflow: hidden !important;
}

.tab-bar {
  height: $-tab-height;
  display: grid;
  grid-template-columns: 1fr 150px;
  justify-content: space-between;
  align-items: center;
}

.tab-container {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1px;
}

.tab {
  width: auto;
  height: $-tab-height;
  margin: 0 0 -1px 0;
  padding: 0 clamp(8px, 4%, 20px);
  background-color: #e9ecef;
  border: 1px solid #cfcfcf;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-weight: $font-weight-bold;
  font-size: $font-size-middle;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: #e2e6ea;
  }

  &.active {
    background-color: #ffffff;
    border-bottom-color: #ffffff;
  }
}

.tab-bar-reload {
  align-self: start;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 0 8px 0 0;

  .label {
    color: #959595;
    font-size: $font-size-small;
    line-height: 1.5;
  }
}

.tab-content {
  height: calc(100% - #{$-tab-height});
  border: 1px solid #cfcfcf;
  border-top-right-radius: 8px;
}

.list-tab {
  position: absolute;
  left: 0;
  top: 16px;
}

#member-map-control {
  ::v-deep .control-wrapper {
    &.left-top-wrapper,
    &.left-bottom-wrapper {
      padding-left: 40px;
    }

    .map-control-ui {
      pointer-events: auto;
    }
  }
}
</style>
